// extracted by mini-css-extract-plugin
export default {"mainContainer":"FormContent_mainContainer__votvi","formContainer":"FormContent_formContainer__RzkOe","submitContainer":"FormContent_submitContainer__QGnSu"};